// * Bootstrap libraries
import "./_bootstrap";

// import Glide from '../../node_modules/@glidejs/glide'

import KeenSlider from 'keen-slider'
import { gsap } from 'gsap'

import { EasePack } from "gsap/EasePack";
import { TextPlugin } from "gsap/TextPlugin";

// * Any other global site-wide JavaScript should be placed below.

function animateResultCount(number, target, step, elem, lastval=null, intervalDelay=300) {
  if(number < target) {
    var interval = setInterval(function() {
      number = parseInt(number)
      var nEl = elem.getElementsByClassName('number')[0]
      nEl.innerText = number
      if (number >= target) {
        nEl.innerText =  lastval ?? `${number}+`
        clearInterval(interval);
        return;
      }
      number+=parseInt(step);
    }, intervalDelay);
  }
  if(target < number) {
    var interval = setInterval(function() {
      number = parseInt(number)
      var nEl = elem.getElementsByClassName('number')[0]
      nEl.innerText = number
      if (target >= number) {
        clearInterval(interval);
        return;
      }
      number -= parseInt(step);
    }, intervalDelay);
  }
}

function onVisible(element, callback) {
  new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if(entry.intersectionRatio > 0) {
        callback(element);
        observer.disconnect();
      }
    });
  }).observe(element);
  if(!callback) return new Promise(r => callback=r);
}

var urbanHistory = JSON.parse('[{"year":1981,"text":"Urbanation launches The Condominium Market Survey, quickly becoming recognized as the \u201cindustry bible\u201d for tracking new condominium projects."},{"year":2010,"text":"Urbanation launches the UrbanRental subscription, the first ever detailed reporting on secondary market rental activity for condominiums."},{"year":2013,"text":"Urbanation launches the first version of our industry-leading online database, bringing together over three decades of market research into an interactive search portal."},{"year":2015,"text":"Urbanation adds new purpose-built rentals to its UrbanRental subscription service, recognizing the emerging interest for new rental development for the first time in decades."},{"year":2016,"text":"Urbanation acquires The Marsh Report, expanding the company\u2019s research into the commercial real estate sector and providing a launch pad for our land sale subscription service."},{"year":2017,"text":"Urbanation expands its coverage of the GTA to include Hamilton, a region gaining prominence for new high-rise development."},{"year":2021,"text":"Urbanation expands into the Ottawa Region by launching a subscription service that tracks new purpose-built rentals, condominium rentals, and future supply."},{"year":2023,"text":"Urbanation partners with Rentsync with the launch of the Rental Expansion database, which tracks market rents in real-time across the entire stock purpose-built rentals."},{"year":2024,"text":"Urbanation expands its geographical coverage further by adding the remaining markets in the Greater Golden Horseshoe, with complete coverage of new and existing condominium and rental projects, and land sale activity."}]');

(function (Drupal) {

  'use strict';

  Drupal.behaviors.urbanationTheme = {
    attach: function (context, settings) {
      var intervalDelay = 400

      //once('bind-visibility-stats', '.stats-wrapper', context).forEach(el => {
      once('bind-visibility-stats', '.animated-stats', context).forEach(el => {
        onVisible(el, (el) => {
          var number = el.dataset.start
          var target = el.dataset.end
          var step = el.dataset.step
          var final = el.dataset.lastval ?? null
          animateResultCount(el.dataset.start, el.dataset.end, el.dataset.step, el, final, intervalDelay)
          intervalDelay += 50
        });
      })

      once('bind-mainnav-frontpage', 'nav.navbar', context).forEach(el => {
        window.addEventListener('scroll', function() {
          // current scroll position
          var lastKnownScrollPosition = window.scrollY;
          if (lastKnownScrollPosition > 50) {
            el.style.display = 'flex';
          }
          if (lastKnownScrollPosition > 120) {
            el.classList.add('fixed-top')
          } else {
            el.classList.remove('fixed-top')
          }
        })
      })

      // once('bind-click-event', '#mainCategoryBurger', context).forEach(el => {
      //   el.addEventListener('click', () => {
      //     // Get the target from the "data-target" attribute
      //     var target = el.dataset.target;
      //     var $target = document.getElementById(target);
      //     // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
      //     el.classList.toggle('is-active');
      //     $target.classList.toggle('is-active');
      //   });
      //   el.classList.add(className);
      // });

      // once('bind-dropdown-event', '.dropdown', context).forEach(el => {
      //   el.addEventListener('click', function(event) {
      //     event.stopPropagation();
      //     el.classList.toggle('is-active');
      //   });
      // });

      // disabled per shaun - 20241115
      // once('bind-aboutpage-history', '.history-alt-wrapper', context).forEach(el => {
      //
      //   gsap.registerPlugin(TextPlugin, EasePack);
      //   var tl = gsap.timeline({delay:0.6, repeat:10, repeatDelay:4});
      //
      //   // var tl = gsap.timeline({repeat:2, repeatDelay:1 });
      //   // var tl2 = gsap.timeline({delay:0.6, repeat:2, repeatDelay:4});
      //   // var yrContainer = document.getElementById("timelineYear")
      //   // var bdContainer = document.getElementById("timelineBody")
      //
      //   var container = document.getElementById("timelineWrapper")
      //
      //   var uHistCount = urbanHistory.length;
      //   var uEl, element, elementBody, elementRow, duration, textDur;
      //   var time = 0;
      //
      //   for(var i=0; i<uHistCount; i++) {
      //     uEl = urbanHistory[i];
      //
      //     elementRow = document.createElement('div')
      //     // elementRow.className = 'row d-flex flex-nowrap flex-row'
      //     elementRow.className = 'row d-flex flex-md-row flex-column'
      //     var yearEle  = document.createElement('div')
      //     var histEle  = document.createElement('div')
      //
      //     element = document.createElement('h3')
      //     element.append(uEl.year)
      //     yearEle.appendChild(element)
      //     yearEle.className = 'year'
      //
      //     elementBody = document.createElement('p')
      //     elementBody.append(uEl.text)
      //     histEle.appendChild(elementBody)
      //     histEle.className = 'history'
      //
      //     elementRow.appendChild(yearEle)
      //     elementRow.appendChild(histEle)
      //
      //     container.appendChild(elementRow)
      //
      //     duration = 5;
      //     textDur = .9
      //
      //     gsap.set(elementRow, {autoAlpha:0, scale: 1, z:0.01})
      //     gsap.set(elementBody, {autoAlpha:0, scale: 0, z:0.01})
      //
      //     tl.to(elementRow, duration, {scale:1,  ease:"slow(0.25, 0.9)"}, time)
      //       .to(elementBody, textDur, {scale:1,  ease:"slow(0.25, 0.9)"}, time)
      //
      //       .to(elementBody, textDur, {autoAlpha:.8, ease:"slow(0.25, 0.9, true)"}, time)
      //       .to(elementRow, duration, {autoAlpha:1, ease:"slow(0.25, 0.9, true)"}, time)
      //
      //       .to(elementRow, 0, {autoAlpha:0})
      //
      //     time += duration - 0.05;
      //   }
      // })

      once('bind-homepage-jumbo', '.hp-transitions', context).forEach(el => {

        // create a reusable effect that swaps text
        gsap.registerEffect({
          name: "swapText",
          effect: (targets, config) => {
            let tl = gsap.timeline({delay: config.delay});
            tl.to(targets, {opacity: 0, duration: config.duration / 2});
            tl.add(() => targets[0].innerText = config.text);
            tl.to(targets, {opacity: 1, duration: config.duration});
            return tl;
          },
          defaults: {duration: 1},
          extendTimeline: true
        });

        var tl = gsap.timeline({repeat: -1});
        tl.swapText(".subtext", {text: "Intelligence.", delay: 1})
          .swapText(".subtext", {text: "Information.", delay: 1})
          .swapText(".subtext", {text: "Insights.", delay: 1}); // back to the start

      })


      once('bind-toggle-event', '.showme', context).forEach(el => {
        el.addEventListener('click', function(event) {
          event.stopPropagation();

          var target = el.dataset.target;
          var $target = document.getElementById(target);

          $target.classList.toggle('hidden');
        });
      });

      // // carouselLatestTrends
      // once('bind-latest-glide', '#carouselLatestTrends', context).forEach(el => {
      //   const carousel = new Carousel('#carouselLatestTrends')
      // });
      // carouselLatestTrends
      once('bind-latest-keen', '.latest_trends_carousel', context).forEach(el => {

        var nextLatestButton = document.querySelector('#nextKeenTrends');
        var prevLatestButton = document.querySelector('#prevKeenTrends');

        var kLatest = new KeenSlider(
          '.latest_trends_carousel', {
            loop: true,
            breakpoints: {
              "(min-width: 769px)": {
                slides: { perView: 2, spacing: 5 },
              },
              "(min-width: 1000px)": {
                slides: { perView: 3, spacing: 10 },
              },
            },
            slides: {
              perView: 1,
              spacing: 10
            },
            created: () => {
              console.log('created')
            }
          }
        )

        nextLatestButton.addEventListener('click', function (event) {
          event.preventDefault();
          kLatest.next();
        })

        prevLatestButton.addEventListener('click', function (event) {
          event.preventDefault();
          kLatest.prev();
        })
      });

      once('bind-inthenews-keen', '.inthenews_carousel', context).forEach(el => {
        var nextNewsButton = document.querySelector('#nextKeenNews');
        var prevNewsButton = document.querySelector('#prevKeenNews');

        var kNews = new KeenSlider(
          '.inthenews_carousel', {
            loop: true,
            breakpoints: {
              "(min-width: 769px)": {
                slides: { perView: 2, spacing: 5 },
              },
              "(min-width: 1000px)": {
                slides: { perView: 3, spacing: 10 },
              },
            },
            slides: {
              perView: 1,
              spacing: 10
            }
          });

        nextNewsButton.addEventListener('click', function (event) {
          event.preventDefault();
          kNews.next();
        })

        prevNewsButton.addEventListener('click', function (event) {
          event.preventDefault();
          kNews.prev();
        })
      });

      once('bind-timeline-keen', '.timeline_carousel', context).forEach(el => {

        // console.log('timeline-carousel');

        var nextButton = document.querySelector('#nextKeenTimeline');
        var prevButton = document.querySelector('#prevKeenTimeline');

        var kContainer = document.getElementById("timelineCarousel");
        function autoplay(run) {
          clearInterval(interval);
          interval = setInterval(function () {
            if (run && kTimeline) {
              kTimeline.next();
            }
          }, 1200);
        }

        var interval = 0;
        var kTimeline = new KeenSlider(
          kContainer, {
            loop: true,
            mode: "free",
            duration: 1800000,
            breakpoints: {
              "(min-width: 769px)": {
                slides: { perView: 3, spacing: 5 },
              },
              "(min-width: 1000px)": {
                slides: { perView: 5, spacing: 10 },
              },
            },
            slides: {
              perView: 2,
              spacing: 10
            }
          });


        nextButton.addEventListener('click', function (event) {
          event.preventDefault();
          kTimeline.next();
        })

        prevButton.addEventListener('click', function (event) {
          event.preventDefault();
          kTimeline.prev();
        })

        // uncomment to enable autoplay
        // kTimeline.next();
        // autoplay(true);
      });

      // timeline animation - disabled
      // once('bind-timeline-keen', '.about-keen-timeline', context).forEach(el => {
      //   var animation = {
      //     duration: 15000, easing: (t) => t
      //   }
      //
      //   var kAboutTimeline = new KeenSlider(
      //     '.about-keen-timeline',  {
      //       loop: true,
      //       renderMode: "performance",
      //       // drag: false,
      //       slides: {
      //         origin: "center",
      //         perView: 1,
      //         spacing: 5,
      //       },
      //       vertical: true,
      //       created(s) {
      //         s.moveToIdx(5, true, animation)
      //       },
      //       updated(s) {
      //         s.moveToIdx(s.track.details.abs + 5, true, animation)
      //       },
      //       animationEnded(s) {
      //         s.moveToIdx(s.track.details.abs + 5, true, animation)
      //       },
      //     });
      // });
    }

    // attach (context, settings) {
    //   once('bind-click-event', 'bmore-more', context).forEach(el => {
    //     el.addEventListener('click', () => {
    //       // Get the target from the "data-target" attribute
    //       var target = el.dataset.target;
    //       var $target = document.getElementById(target);
    //       $target.classList.toggle('hidden');
    //     });
    //   });
    //
    // }
  };



} (Drupal));

